import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    title: 'mt-10 mb-6 text-2xl leading-[140%] font-medium lg:mt-0 lg:text-3xl',
    items: 'flex flex-col gap-1',
    item: 'bg-brand-100 p-4',
    top: 'flex items-center justify-between',
    bottom: 'flex items-center justify-between',
    date: 'text-system-gray-700 text-[12px]',
    order: 'heading-s max-w-[60%] lg:max-w-none',
    points:
      'text-text-main-inversion bg-bg-items-error flex gap-1 rounded-[40px] px-2 py-1 text-xs font-medium',
    icon: 'h-5 w-5'
  },
  variants: {
    type: {
      accrual: {
        points: 'bg-brand-400'
      }
    }
  }
});
